// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"c279d047f8112ea28b6c","113":"64c8817670e4990f530d","114":"a598cb1ad1fe4278fc6f","163":"dd06b3c25478b11e727e"}[chunkId] + ".chunk.js";
};